import React, { FC } from 'react'

import { Alert } from '@app/types/alert'
import Box from '@mui/material/Box'
import { AppIcon } from '@app/components/AppIcon'
import { useTimeController } from '@app/hooks/contexts/timeController/TimeControllerContext'

import theme from '../../../../../../../theme'
import AppAlertBase from '../../../../../../../components/AppAlertBase'
import AlertEventTime from '../../../../../../../components/AlertEventTime'

interface SidebarMskRpeAlertProps {
	readonly alert: Alert
}

const SidebarMskRpeAlert: FC<SidebarMskRpeAlertProps> = ({
	alert,
}: SidebarMskRpeAlertProps) => {
	const {
		formatters: { df },
	} = useTimeController()
	const eventTime = df(alert.op?.addedTimestamp)
	const title = alert.data?.alert_description || ''

	const increaseOrDecreaseIconType = title.match('Decrease')
		? 'decreaseTendency'
		: 'increaseTendency' // should check type of alert. These func is mock.!!!!!

	return (
		<>
			<AppAlertBase
				iconSlot={
					<Box position={'relative'}>
						<AppIcon type={'mskRpeUp'} width={32} height={27} />

						<AppIcon
							type={increaseOrDecreaseIconType}
							style={{
								position: 'absolute',
								bottom: -25,
								right: -14,
							}}
						/>
					</Box>
				}
				iconBoxSx={{
					bgcolor: theme.palette.secondary.light,
					height: 'auto',
				}}
				title={title}
			/>

			<AlertEventTime eventTime={eventTime} />
		</>
	)
}

export default SidebarMskRpeAlert
